import type { SessionEvent } from "@/mds/components/sessions/session.types";
import type { SessionEventModelData } from "@/store/sessions/types";

export const exportSessionEvents = (sessionEvents: SessionEventModelData[]): SessionEvent[] => {
  return sessionEvents.map(event => ({
    id: event.id,
    session_id: event.session_id,
    locally_created_at: event.locally_created_at,
    internal_created_at: event.locally_created_at,
    internal_updated_at: event.locally_created_at,
    feedbackGiven: event.feedback_given,
    data: {
      kind: event.kind,
      value: event.value_json,
    } as SessionEvent["data"],
  }));
};
